/*
 *
 * Copyright (C) 2022 NetBase Solutions, Inc.
 * 3960 Freedom Circle Suite 201 Santa Clara, CA 95054
 * All rights reserved.
 */

import CountType, { CountTypeStrings } from 'enums/CountType'

export const DEFAULT_MAX_EXACT_ITEM = 100

export const getThemeColorByCountType = (countType: CountTypeStrings) => {
  const colorMap = {
    [CountType.MENTIONS]: 'metric.mainMetrics.mentions',
    [CountType.POSTS]: 'metric.mainMetrics.post',
    [CountType.AUTHORS]: 'metric.mainMetrics.authors'
  }
  return colorMap[countType] || ''
}

export const getNumberFormatter = () =>
  new Intl.NumberFormat(undefined, {
    minimumFractionDigits: 0,
    maximumFractionDigits: 3
  })
